import React, { useState, useEffect } from "react";
import DashboardNav from "./dashboardNav";
import classes from "./TravelPackages.module.css";
import { FaMapMarkerAlt, FaHotel, FaCar, FaUserTie, FaWalking } from "react-icons/fa";
import { BUDGETS, PACKAGES } from "./TravelPackagesData";
import { useNavigate } from "react-router-dom";
import Spinner from "../spinner";

const TravelPackages = () => {
    const navigate = useNavigate();
    const [selectedBudgets, setSelectedBudgets] = useState<string[]>([]);
    const [filteredPackages, setFilteredPackages] = useState(PACKAGES);
    const [sortBy, setSortBy] = useState("Recommended");
    const [spin, setSpin] = useState(false);

    useEffect(() => {
        let sorted = [...PACKAGES];
        if (sortBy === "PriceLowToHigh") sorted.sort((a, b) => a.price - b.price);
        if (sortBy === "PriceHighToLow") sorted.sort((a, b) => b.price - a.price);

        if (selectedBudgets.length === 0) {
            setFilteredPackages(sorted);
        } else {
            const activeBudgetTests = BUDGETS.filter(b => selectedBudgets.includes(b.id)).map(b => b.test);
            setFilteredPackages(sorted.filter(pkg => activeBudgetTests.some(testFunc => testFunc(pkg.price))));
        }
    }, [selectedBudgets, sortBy]);

    const handleBudgetChange = (budgetId: string) => {
        setSelectedBudgets(prev => {
            if (prev.includes(budgetId)) {
                return prev.filter(id => id !== budgetId);
            } else {
                return [...prev, budgetId];
            }
        });
    };

    const handleViewDetail = (pkg: any) => {
        navigate(`/dashboard/travel-packages/${pkg.id}`);
    };

    return (
        <div className={classes.mainContainer}>
            {spin && <Spinner />}
            <DashboardNav active={"travelPackages"} />

            <div style={{ marginTop: '30px' }}>
                <div className={classes.header}>
                    <h2>Curated Travel Experiences</h2>
                    <p>Discover our handpicked collection of premium holidays.</p>
                </div>

                <div className={classes.layout}>
                    <div className={classes.sidebar}>
                        <div className={classes.sidebarTitle}>Filters</div>
                        <div>
                            <div className={classes.filterGroupTitle}>BUDGET (PER PERSON)</div>
                            <div className={classes.filterList}>
                                {BUDGETS.map(budget => (
                                    <label key={budget.id} className={classes.filterItem}>
                                        <input
                                            type="checkbox"
                                            checked={selectedBudgets.includes(budget.id)}
                                            onChange={() => handleBudgetChange(budget.id)}
                                        />
                                        {budget.label}
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className={classes.content}>
                        <div className={classes.listHeader}>
                            <span className={classes.resultsCount}>{filteredPackages.length} packages found</span>
                            <div className={classes.sortWrapper}>
                                <span className={classes.sortLabel}>Sort</span>
                                <select
                                    className={classes.sortSelect}
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="Recommended">Recommended</option>
                                    <option value="PriceLowToHigh">Price: Low to High</option>
                                    <option value="PriceHighToLow">Price: High to Low</option>
                                </select>
                            </div>
                        </div>

                        <div className={classes.packageList}>
                            {filteredPackages.map(pkg => (
                                <div key={pkg.id} className={classes.packageCard}>
                                    <div className={classes.packageImageWrapper}>
                                        <img src={pkg.image} alt={pkg.title} />
                                        {pkg.tag && <div className={classes.tag}>{pkg.tag}</div>}
                                    </div>
                                    <div className={classes.packageDetails}>
                                        <div>
                                            <div className={classes.nightPill}>{pkg.nights} Nights / {pkg.nights + 1} Days</div>
                                            <div className={classes.packageTitle}>{pkg.title}</div>
                                            <div className={classes.packageLocation}>
                                                <FaMapMarkerAlt />
                                                {pkg.stops.map(s => `${s.nights}N ${s.name}`).join(' • ')}
                                            </div>

                                            <div className={classes.features}>
                                                <div className={classes.feature}><FaHotel className={classes.featureIcon} /> <span>{pkg.hotels} Hotels</span></div>
                                                <div className={classes.feature}><FaWalking className={classes.featureIcon} /> <span>{pkg.activities} Activities</span></div>
                                                <div className={classes.feature}><FaCar className={classes.featureIcon} /> <span>Transfers</span></div>
                                                <div className={classes.feature}><FaUserTie className={classes.featureIcon} /> <span>Guide</span></div>
                                            </div>
                                        </div>

                                        <div>
                                            <div className={classes.divider}></div>
                                            <div className={classes.footer}>
                                                <div className={classes.priceSection}>
                                                    <p>Starting From</p>
                                                    <div className={classes.price}>
                                                        ₹{pkg.price.toLocaleString('en-IN')} <span>/ person</span>
                                                    </div>
                                                </div>
                                                <button className={classes.viewButton} onClick={() => handleViewDetail(pkg)}>
                                                    VIEW DETAIL
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TravelPackages;
